import { eventUtil } from '../utils';

export const httpRequestEvents = {
    onUnauthorized: eventUtil.createEvent<void>('onUnauthorized'),
};